import { wrapNextPage } from '#/utils/next-wrappers/NextPage'
import Layout from './layout'
import Loading from './loading'
import Page from './page'

export default wrapNextPage(Page, { Layout, Loading })
